// import Http from './http'; // não precisa de .js

import axios from "axios";
import api from "../utils/api";

// const token = !localStorage.getItem('token')?false:localStorage.getItem('token')
// if(token)
//   axios.defaults.headers.get['Authorization'] = 'Bearer ' + token

// const config = {
//   headers: {
//     'Authorization': 'Bearer ' + token,
//     'Access-Control-Allow-Origin':'*'
//   }
// }
let createContract_url = process.env.VUE_APP_AUTENTIQUE_CREATECONTRACT;
let listContractById_url = process.env.VUE_APP_AUTENTIQUE_CONTRACT_BY_ID;

export const createContract = (data) => {
  return api.post(createContract_url, data);
};

export const listContractById = (id) => {
  return axios.get(listContractById_url + "/" + id);
};
